/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateTBankPaymentMutationRequest, CreateTBankPaymentMutationResponse, CreateTBankPayment400, CreateTBankPayment401, CreateTBankPayment404, CreateTBankPayment500 } from "../entities/CreateTBankPayment";

function getCreateTBankPaymentUrl() {
  const res = { method: 'POST', url: `/api/v1/payments/tbank` as const }
  return res
}

/**
 * @description Создает новый платеж через платежную систему T-Bank.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Минимальная сумма платежа: 240 RUB
 * - Максимальная сумма платежа: 9000 RUB
 * - Максимальная длина description: 140 символов
 * **Процесс:**
 * 1. Валидация входных данных
 * 2. Создание записи в БД
 * 3. Отправка запроса в T-Bank API
 * 4. Возврат URL для оплаты
 * @summary Инициализация платежа через T-Bank
 * {@link /api/v1/payments/tbank}
 */
export async function createTBankPayment(data: CreateTBankPaymentMutationRequest, config: Partial<RequestConfig<CreateTBankPaymentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateTBankPaymentMutationResponse, ResponseErrorConfig<CreateTBankPayment400 | CreateTBankPayment401 | CreateTBankPayment404 | CreateTBankPayment500>, CreateTBankPaymentMutationRequest>({ method : "POST", url : getCreateTBankPaymentUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}